<template>
  <div class="advertising">
    <NavBar1 type="product" />
<!--    <NavBar2 v-if="scrollTop>0" type="product" />-->
    <div class="banner">
      <div class="title">社群运营</div>
      <div class="subtitle">基于企微/社群的用户运营与行为溯源，实现裂变增长</div>
    </div>
    <div class="content">
      <div class="wow slideInUp level-content">
        <div class="title">私域流量精准溯源与分层运营</div>
        <div class="subtitle">
          构建从企微/社群的全链路用户身份与行为溯源。<br />
          并基于此数据完成用户分层，促进复购和老带新<br />
          转化，提升用户生命周期的价值<br />
        </div>
      </div>
    </div>
    <div class="exhibition">
      <div class="exhibition_con">
        <div>新闻与活动</div>
        <div class="wow slideInUp">
          <div class="exhibition_item" @click="article('https://cloud.tencent.com/developer/article/1892234?from=article.detail.1902177')">
            <div class="exhibition_img">
              <img src="https://resource.51beauty.com.cn/f17ab896-e595-4a3e-bda8-7258a73e1e48?imageslim" alt="">
            </div>
            <div class="exhibition_text">
              <div class="title">腾讯SaaS加速器三期总决选</div>
              <div class="subtitle">云晰科技从1100家报名SaaS企业中顺利突围，获得最终角逐Top 40席位的入场券。</div>
            </div>
          </div>
          <div class="exhibition_item" @click="article('https://cloud.tencent.com/document/product/306/47166')">
            <div class="exhibition_img">
              <img src="https://resource.51beauty.com.cn/a5826992-7c89-4adf-bbca-c986ca84e718?imageslim" alt="">
            </div>
            <div class="exhibition_text">
              <div class="title">云晰科技已通过腾讯云千帆计划复选</div>
              <div class="subtitle">营销云产品已上架腾讯云市场，成为“千帆甄选”推荐产品。</div>
            </div>
          </div>
          <div class="exhibition_item" @click="article('https://baijiahao.baidu.com/s?id=1718001203675989497&wfr=spider&for=pc')">
            <div class="exhibition_img">
              <img src="https://resource.51beauty.com.cn/4bc47af4-78d0-4a64-95b3-be41e94b212e?imageslim" alt="">
            </div>
            <div class="exhibition_text">
              <div class="title">云晰科技和企业微信官方合作组织沙龙会</div>
              <div class="subtitle">云晰与企业微信深度合作共创，将企微作为腾讯新流量生态的结合点，帮助客户探索私域增长…</div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- 专注消费医疗 -->
    <Bottom />
    <Contact />
  </div>
</template>
<script>
  import NavBar1 from "@/components/navBarProduct.vue";
  // import NavBar2 from "@/components/navBar.vue";
  import Bottom from "@/components/bottom.vue";
  import Contact from '@/components/contact.vue'

  import { WOW } from 'wowjs'
  export default {
    components: {
      NavBar1,
      // NavBar2,
      Bottom,
      Contact
    },
    data() {
      return {
        scrollTop:0,
        appointmentVisible:false
      };
    },
    mounted() {
      new WOW().init()
      window.addEventListener('scroll',this.handleScroll,true)
    },
    methods: {
      // 关闭预约弹层
      closeAppoint (e) {
        this.appointmentVisible = e
      },
      // 打开预约弹层
      openAppoint () {
        this.appointmentVisible = true
      },
      handleScroll(){
        let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        this.scrollTop = scrollTop
      },
      article(href){
        window.location = href
      }
    },
  };
</script>
<style scoped lang="less">
  .advertising{
    .banner{
      background: url("https://resource.51beauty.com.cn/qianduan_forever/5021dbe18b4343fd8c144ef5f38cd38a/community-banner.png") no-repeat;
      background-size: cover;
      width: 375px;
      height: 94px;
      display: flex;
      flex-direction: column;
      gap: 7px;
      justify-content: center;
      .title{
        font-size: 10px;
        color: #fff;
        font-weight: 500;
        text-align: center;
      }
      .subtitle{
        font-size: 6px;
        color: #fff;
        text-align: center;
      }
    }
    .content{
      .level-content {
        background: url("https://resource.51beauty.com.cn/qianduan_forever/e2832dbb127d4eac969d605234773d03/level.png") no-repeat;
        background-size: cover;
        width: 375px;
        height: 168px;
        display: flex;
        flex-direction: column;
        .title {
          font-weight: 400;
          font-size: 8px;
          color: #252525;
          margin-top: 25px;
          align-self: center;
        }
        .subtitle {
          margin-left: 69px;
          font-weight: 400;
          font-size: 4px;
          color: #727882;
          line-height: 9px;
          margin-top: 49px;
        }
      }
    }
    .exhibition{
      background: #FAFBFD;
      padding-bottom: 29px;
      .exhibition_con{

        >div:nth-child(1){
          font-size: 8px;
          font-weight: bold;
          text-align: center;
          padding: 29px 0 12px 0;
        }
        >div:nth-child(2){
          width: 235px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          .exhibition_item{
            width: 73px;
            height: 81px;
            background: #fff;
            cursor: pointer;
            transition: .3s;
            border-radius: 3px;
            .exhibition_img{
              height: 55px;
              background: #FFFFFF;
              margin: 0 auto;
              img{
                width: 59px;
                margin: 0 auto;
                margin-top: 4px;
                display: block;
              }
              box-shadow: 0px 2px 4px 0px rgba(55,99,170,0.06);
            }
            >.exhibition_text{
              background: #fff;
              width: 100%;
              height: 26px;
              margin-top: .3px;
              box-shadow: 0px 2px 4px 0px rgba(55,99,170,0.06);
              border-radius: 0px 0px 3px 3px;
              >div:nth-child(1){
                font-weight: bold;
                font-size: 3px;
                margin-left: 5px;
                padding-top: 5px;
              }
              >div:nth-child(2){
                padding: 0 5px;
                margin-top: 2px;
                color: #273755;
                font-size: 3px;
                overflow:hidden;
                text-overflow:ellipsis;
                display:-webkit-box;
                -webkit-box-orient:vertical;
                -webkit-line-clamp:2;
              }
            }
          }
          .exhibition_item:hover{
            transform: scale(1.1);
          }
        }
      }
    }
  }
</style>